import React from "react"
import PortableText from "react-portable-text"
import styled from "styled-components/macro"
import colors from "../../scripts/colors.ts"
import "@fontsource/noto-sans-jp/300.css"
import "@fontsource/raleway/500.css"
import ChevronRight from "../../images/iconmonstr-arrow-24.svg"
import ChevronOLDown from "../../images/iconmonstr-arrow-24---outline.svg"

export const ArticleContentStyles = styled.div`
  a {
    font-weight: 500;
  }
`

const H2Styles = styled.h2`
  display: flex;
  flex-direction: column;
  margin: 1.65em 0 1.25em;
  font-weight: 300;
  font-size: 25px;
  letter-spacing: 0.18em;
  border: 2px solid ${colors("grey", "xlt")};
  padding: 17px 20px 23px;
  text-align: center;
  @media screen and (min-width: 500px) {
    display: inline-flex;
    width: auto;
  }
`

const Header2Arrow = styled(ChevronOLDown)`
  color: ${colors("purple")};
  height: 17px;
  margin: 13px 0 -33px;
`

const Header2 = ({ children }) => {
  return (
    <H2Styles>
      {children}
      <Header2Arrow />
    </H2Styles>
  )
}

export const ULStyles = styled.ul`
  padding: 0;
  margin: 1.75rem 0;
  list-style-type: none;
`

export const OLStyles = styled(ULStyles)`
  counter-reset: article-ol-counter;
`

export const LIStyles = styled.li`
  margin-bottom: 0.75rem;
  ul & {
    display: flex;
  }
  ol & {
    display: list-item;
    counter-increment: article-ol-counter;
    display: flex;
    &::before {
      content: counter(article-ol-counter) "";
      color: ${colors("purple")};
      font-family: "Noto Sans JP", sans-serif;
      font-size: 17px;
      font-weight: 900;
      margin-right: 1rem;
    }
  }
`

export const LiArrow = styled(ChevronRight)`
  color: ${colors("purple")};
  height: 0.75rem;
  margin-top: 0.55rem;
  margin-right: 0.5rem;
  ol & {
    display: none;
  }
`

export const ListItem = ({ children }) => {
  return (
    <LIStyles>
      <LiArrow className="LiArrow" />
      <div>{children}</div>
    </LIStyles>
  )
}

export const StrongStyles = styled.strong`
  color: ${colors("blue")};
`

const ArticleContent = ({ content }) => {
  return (
    <ArticleContentStyles>
      <PortableText
        content={content}
        serializers={{
          p: ({ children }) => <PStyles>{children}</PStyles>,
          h2: ({ children }) => <Header2>{children}</Header2>,
          ul: ({ children }) => <ULStyles>{children}</ULStyles>,
          ol: ({ children }) => <OLStyles as="ol">{children}</OLStyles>,
          li: ({ children }) => <ListItem>{children}</ListItem>,
          strong: ({ children }) => <StrongStyles>{children}</StrongStyles>,
          a: ({ children }) => <ContentLink>{children}</ContentLink>,
        }}
      />
    </ArticleContentStyles>
  )
}

export default ArticleContent
